import { Typography } from "@mui/material";
import styled from "@emotion/styled";

export const TypographyWithDisabled = styled(Typography)<{ disabled: number }>(
  ({ theme, disabled = 0 }) => ({
    color: disabled === 1 ? theme.palette.text.disabled : "inherit",
  })
);
